<template>
  <div class="row mt-md-5">
    <div class="col-12" v-if="nombre.length == 0">
      <div class="text-center mt-4 row justify-content-center">
        <h3>Validar Acceso</h3>
        <h6 class="mt-5">Ingresa la Matricula o Clave de empleado</h6>
        <form
          autocomplete="off"
          class="mb-5 col-md-6 col-12"
          v-on:submit.prevent="ConsultarAlumno()"
        >
          <div class="mb-3">
            <input
              :disabled="loading"
              v-model="matricula"
              type="text"
              class="form-control text-center"
              id="matricula"
            />
          </div>
          <div class="m-3">
            <button
              :disabled="matricula.length == 0 || loading"
              type="submit"
              class="btn btn-primary"
            >
              Validar
              <i v-if="loading" class="ml-1 fas fa-spinner fa-spin"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div
      class="col-12 mt-3"
      v-if="nombre.length > 0 && lista_carreras.length == 0"
    >
      <div class="row justify-content-center">
        <div class="col-12 text-end">
          <button class="btn btn-primary" v-on:click="Limpiar">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
        <div class="col-md-6 text-center" v-if="foto != null">
          <img :src="'data:image/png;base64,' + foto" alt="" />
        </div>
        <div class="col-12 text-center mt-3">
          <h6>{{ enrollment }}</h6>
        </div>
        <div class="col-12 text-center">
          <h6>{{ nombre }}</h6>
        </div>
        <div class="col-12 mt-3 mb-4 text-center">
          <i
            v-if="puede_pasar"
            style="font-size: 70px;"
            class="fas text-success fa-lg fa-check-circle"
          ></i>
          <i
            v-else
            style="font-size: 70px;"
            class="fas text-danger fa-lg fa-times-circle"
          ></i>
        </div>
        <div
          v-if="veces_escaneados > 0 && puede_pasar"
          class="col-12 mb-3 text-center"
        >
          <h6>
            {{ veces_escaneados }}
            {{ veces_escaneados > 1 ? "veces" : "vez" }} escaneado el día de hoy
          </h6>
        </div>
        <div
          v-for="motivo of motivos"
          class="col-12 mb-3 text-center text-danger"
        >
          {{ motivo }}
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" id="modal_carreras">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Elige la carrera o dependencia</h5>
          </div>
          <div class="modal-body">
            <div class="row ps-3 pt-4">
              <div
                class="form-check col-12 mb-4"
                v-for="carrera of lista_carreras"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  v-on:change="ConsultarAlumno"
                  :id="carrera.clave"
                  v-model="clave_carrera"
                  :value="carrera.clave"
                />
                <label class="form-check-label" :for="carrera.clave">
                  {{ carrera.nombre }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

const axios = require("axios");
import {mapActions, mapState} from "vuex";
import {auth} from "@/firebase.js";
export default {
  data() {
    return {
      loading: true,
      puede_pasar: true,
      matricula: "",
      nombre: "",
      foto: "",
      hora_inicio: "",
      motivos: [],
      hora_fin: "",
      clave_carrera: null,
      lista_carreras: [],
      modalToggle: null,
      myModal: null,
      veces_escaneados: 0
    };
  },
  methods: {
    Limpiar() {
      this.matricula = "";
      this.nombre = "";
      this.foto = "";
      this.hora_inicio = "";
      this.motivos = [];
      this.hora_fin = "";
      this.lista_carreras = [];
      this.clave_carrera = null;
      this.loading = false;
      this.veces_escaneados = 0;
      $(document).ready(function() {
        document.getElementById("matricula").focus();
      });
    },
    ConsultarAlumno() {
      let matricula = "";
      console.log('this.matricula',this.matricula);
      let myArr = this.matricula.split("");
      let encontre = false;
      if(myArr.length>10){
        for (let index = 0; index < myArr.length; index++) {
          if (parseInt(myArr[index]) >= 0) {
            matricula = matricula + myArr[index].toString();
            encontre = true;
          } else if (encontre) {
            break;
          }
        }
        this.matricula = matricula;
      }else{
        matricula=this.matricula;
      }
      console.log('this.matricula',this.matricula);
      let datos = {
        matricula: matricula,
        clave_carrera: null
      };
      this.lista_carreras = [];
      var that = this;
      this.loading = true;
      axios
        .post(process.env.URL_API + "/api/survey/allowStudent", datos, {
          headers: {
            Authorization: "Bearer " + this.usuario.token
          }
        })
        .then(async function(response) {
          that.nombre = response.data.nombre;
          that.puede_pasar = response.data.puede_pasar;
          if (response.data.foto == undefined) {
            that.foto = null;
          } else {
            that.foto = response.data.foto;
          }
          if (response.data.times_used != undefined) {
            that.veces_escaneados = response.data.times_used;
          }
          that.motivos = response.data.motivos;
          that.hora_inicio = response.data.hora_inicio;
          that.hora_fin = response.data.hora_fin;
          that.loading = false;

          if (response.data.lista_carreras != null) {
            that.lista_carreras = response.data.lista_carreras;
            that.myModal.show(that.modalToggle);
          } else {
            let music = new Audio("static/audio/no_puede_entrar.mp3");
            that.myModal.hide();
            if (!that.puede_pasar) {
              music.play();
            }
            setTimeout(() => {
              that.Limpiar();
              if (!that.puede_pasar) {
                music.pause();
              }
            }, 2000);
          }

        })
        .catch(async function(error) {

          that.loading = false;

          if (error.response) {
            if (error.response.status == 401) {

              if(that.usuario.intentos<1){
                that.usuario.intentos++;
                await that.ActualizarUsuario(true);
                that.ConsultarAlumno();
              }else{
                that.usuario.intentos=0;
                swal("Favor de Iniciar Sesión", "", "error");
                auth.signOut();
                that.$router.push({name:'Login'});
              }

            } else if (error.response.status == 403) {
              swal(
                "No tienes permiso para realizar esta acción",
                "",
                "warning"
              );
            } else if (error.response.status == 404) {
              swal("El alumno o empleado no existe", "", "warning");
            } else if (error.response.status == 400) {
              swal(
                "El alumno o empleado no ha iniciado sesión en la aplicación",
                "",
                "warning"
              );
            } else if (error.response.status == 412) {
              swal("No pertenece a tu dependencia", "", "error");
            } else {
              swal("Error", "Favor de intentar mas tarde", "error");
            }
          } else {
            swal("Error", "Favor de intentar mas tarde", "error");
          }
          let music = new Audio("static/audio/no_puede_entrar.mp3");
          music.play();
          setTimeout(() => {
            that.Limpiar();
            music.pause();
          }, 2000);


        });
    },
    ...mapActions(['ActualizarUsuario'])
  },
  created() {
    if (this.usuario.token == null) {
      this.$router.push({ name: "Login" });
    }
  },
  mounted() {
    var that = this;
    this.loading = false;
    this.modalToggle = document.getElementById("modal_carreras"); // relatedTarget
    this.myModal = new bootstrap.Modal(this.modalToggle, {
      keyboard: false,
      backdrop: false
    });
  },
  computed: {
    ...mapState(["usuario"]),
    enrollment(){
      if(this.matricula && this.matricula.slice(4,7) === '111' && this.matricula[0] === '6') return this.matricula.slice(7)
      return this.matricula
    }
  }
};
</script>

<style>
.bg-uanl {
  background: #004a8f !important;
  color: #ffffff !important;
}
.modal-open {
  background-color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/Ingresar.vue